import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Label } from '@/components/ui/label'
import { Textarea as TextAreaComponent } from '@/components/ui/textarea'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'

export const Textarea: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
    rows?: number
  }
> = ({ name, defaultValue, errors, label, register, required, rows = 3, width }) => {
  const placeholder = required ? `${label} *` : label

  return (
    <Width width={width}>
      <Label className="sr-only" htmlFor={name}>
        {label}
        {required && <span className="sr-only"> (required)</span>}
      </Label>

      <TextAreaComponent
        className="h-[110px] min-h-[110px]"
        defaultValue={defaultValue}
        id={name}
        placeholder={placeholder}
        rows={rows}
        {...register(name, { required: required })}
      />

      {errors[name] && <Error name={name} />}
    </Width>
  )
}
